import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi, logout } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';

const version = StFeatureFlagFlags.UserLegacyServiceVersionStaging.getValue();
const gateway = StFeatureFlagFlags.gatewayStaging.getValue();

const afterParser = response => response.data;

export function error401Handler() {
  logout();
  window.location.reload();
}

export class UserLegacyServiceStaging extends Service {
  constructor(gateway, version) {
    const api = createApi(`upms-legacy/${version}/user/`, gateway, { error401Handler });
    super(api, { afterParser });
  }

  me() {
    return this.find({ url: 'me' });
  }
}

export default new UserLegacyServiceStaging(gateway, version);
